import { WebApiSettings } from './types';
import { ResponseData } from '../abortable-promise';
import { PanelSettings, Panel } from '../panel';
import { UserAgent } from '../utils';
import { Notification, Queue } from '../notification';
import { Cookies } from '../cookie';
import { Facet } from '../facet';
import { FilterBuilder } from '../filter-builder';
import { SearchAttributeBuilder } from '../search-attribute-builder';

export class WebAPI {
  url: string;
  market: string;
  notify: Notification;
  agent: UserAgent;
  utils = {
    Facet,
    FilterBuilder,
    SearchAttributeBuilder
  };

  constructor(settings: WebApiSettings) {
    if (!(settings.url || settings.clusterId)) {
      throw new Error('Specify a url in the settings object');
    }

    if (!settings.market) {
      throw new Error('Market must be specified');
    }

    this.url = settings.url ? settings.url : `https://${settings.clusterId}.api.esales.apptus.cloud/api/v2`;

    const ending = '/api/v2';
    const endIndex = this.url.length - ending.length;

    if (this.url.lastIndexOf(ending) !== endIndex) {
        this.url  += '/api/v2';
    }

    this.market = settings.market;
    this.notify = new Notification(this.url, this.market, Queue, Cookies);
    this.agent = new UserAgent(window.navigator);

    // Make sure to set customerKey and sessionKey at the start
    Cookies.customerKey();
    Cookies.sessionKey();
  }

  panel(path: string, args: any): Promise<ResponseData> {
    if (!args) args = {};
    if (this.agent.isBot()) args.notify = false;

    const panel = new Panel({
      url: this.url,
      path,
      args: { ...args },
      market: this.market,
      sessionKey: Cookies.sessionKey(),
      customerKey: Cookies.customerKey()
    });

    return panel.createPanelRequest();
  }
}
